import React from 'react';

import img1 from '../images/background-1.jpg'
import img2 from '../images/background-2.jpg'
import img3 from '../images/background-3.jpg'
import img4 from '../images/background-4.jpg'
import img5 from '../images/background-5.jpg'
import img6 from '../images/background-6.jpg'
import img7 from '../images/background-7.jpg'
import img8 from '../images/background-8.jpg'
import img9 from '../images/background-9.png'

import mobileImg1 from '../images/background-1.jpg'
import mobileImg2 from '../images/mobile-background-2.jpg'
import mobileImg3 from '../images/mobile-background-3.jpg'
import mobileImg4 from '../images/mobile-background-4.jpg'
import mobileImg5 from '../images/mobile-background-5.jpg'
import mobileImg6 from '../images/mobile-background-6.png'
import mobileImg7 from '../images/mobile-background-7.jpg'
import mobileImg8 from '../images/mobile-background-8.jpg'
import mobileImg9 from '../images/background-9.png'

export const openLegalText = (text) => (e) => {
  const el = document.getElementById('legal-snackbar')
  const textEl = document.getElementById('legal-snackbar-text')
  if(el) {
    el.classList.add('visible-snackbar');
    if(textEl) textEl.textContent = text
  }
}

export const closeSnackbar = () => {
  const el = document.getElementById('legal-snackbar')
  if(el) {
    el.classList.remove('visible-snackbar');
  }
}

export const LEGAL_TEXT = '*Based on original equipment manufacturers(OEM)/automotive manufacturers that sell all-electric vehicles and have publicly announced charging networks.  Department of Energy data used. FordPass, compatible with select smartphone platforms, is available via a download. Message and data rates may apply.'
export const LEGAL_TEXT_2 = '*Based on California greenhouse gas agreements published as of September, 2020. https://ww2.arb.ca.gov/news/framework-agreements-clean-cars'

export const content = [
  {
    backgroundImage: "https://serverless-app-example-test.s3-us-west-2.amazonaws.com/Sustainability+-+Phase+1+-+NoCharge.mp4", //man w dog
    mobileBackgroundImage: mobileImg1,
    isVideo: true,
    poster: img1,
    id: 'world',
    title: <>WHAT GOOD IS IT TO BUILD THE WORLD’S BEST CARS AND TRUCKS <b>WITHOUT THINKING ABOUT THE WORLD WE BUILD THEM FOR?</b></>
  },
  {
    backgroundImage: img2, //ccloseup tree trunk
    mobileBackgroundImage: mobileImg2,
    // mobileBackgroundImage: mobileImg2,
    id: 'built-for-progress',
    title: <>BUILT FOR <b>PROGRESS</b></>,
    showPlayButton: true,
    subtitle: <>We are committed to building a more sustainable transportation future. We’ve fundamentally shifted the way we operate to put sustainability at the core of everything we do — from manufacturing and renewable materials, to ever-more fuel efficient engines and widespread electrification of our fleet.
      <br/><b  style={{position: 'relative', top: '10%'}}>And we're just getting started.</b></>,
      ctaText: 'Read How We Take A Stand For Sustainability',
      ctaUrl: 'https://www.linkedin.com/pulse/from-detroit-paris-time-climate-progress-bill-ford/?trackingId=JvqdC%2FbWaxFUkQesie0kfg%3D%3D',//'https://www.youtube.com/watch?v=iErlyt0AiRI&feature=youtu.be'
  },
  {
    backgroundImage: img3, //trees
    mobileBackgroundImage: img3,//mobileImg3,
    id: 'carbon-neutral',
    title: <>A <b>Carbon Neutral</b> Car Company?</>,
    subtitle: <>We're designing the world's most innovative electric vehicles that are good for the planet and great to drive. Soon we'll make them all carbon neutral. Some say it’s impossible.
      <br/><b>We build for progress.</b> </>,
    ctaText: 'See Our Sustainability Report',
    ctaUrl: 'https://corporate.ford.com/microsites/sustainability-report-2020/index.html'

  }, {
    backgroundImage: img4, //car with man
    mobileBackgroundImage: mobileImg4,
    id: 'going-electric',
    title: <>Our Icons <b>Are Going Electric.</b></>,
    subtitle: <>Mustang Mach-E, Ford Transit and... F-150. And we’ll invest more than $11.5 billion in electrification through 2022.</>,
    ctaText: 'Learn More About The Mach-E',
    ctaUrl: 'https://media.ford.com/content/fordmedia/fna/us/en/news/2020/06/30/all-electric-ford-mustang-mach-e-gets-upgraded.html'
  },
  {
    backgroundImage: img5, //planet
    mobileBackgroundImage: mobileImg5,
    id: 'charging-network',
    title: <>We Are Delivering North America's <b>Largest Public Charging Network.</b></>,
    subtitle: <>The FordPass Charging Network is the largest public charging network in North America offered by automotive manufacturers with over 13,500 charging stations (almost 40,000 plugs)<sup className="clickable-asterik" onClick={openLegalText(LEGAL_TEXT)}>*</sup> and growing.  </>,
    ctaText: 'Find A Charging Station Near You',
    ctaUrl: 'https://www.ford.com/buy-site-wide-content/overlays/try-the-tech/',//'https://ford-landing.herokuapp.com/', //prob links to the map
    finePrint: LEGAL_TEXT
  },
  {
    backgroundImage: img6, //beige car seat
    mobileBackgroundImage: mobileImg6,
    id: 'soy-seats',
    title: <><b>Soy Seats</b> Bring Comfort To Passengers And <b>The Planet.</b></>,
    subtitle: <>Since 2007, we've been replacing petroleum-based seat foam with sustainable soy materials. To date, we've made 25 million vehicles in North America with it. </>,
    ctaText: 'Learn About Our Sustainable Materials',
    ctaUrl: 'https://media.ford.com/content/fordmedia/fna/us/en/news/2017/11/02/from-seed-to-seat--how-soy-foam-proved-key-to-fords-push-to-use-.html'
  },
  {
    backgroundImage: img7, //nature closeup
    mobileBackgroundImage: mobileImg7,
    id: 'coffee-grounds',
    title: <>Serving Parts Made From <b>Coffee Bean Waste.</b> </>,
    subtitle: <>Sustainability requires innovation and ingenuity. We worked with McDonald’s USA to turn the byproduct of its coffee roasting processes into a vehicle part that curbs energy use in production by up to 25%.  </>,
    ctaText: 'Learn How We Are Reducing Landfill Waste',
    ctaUrl: 'https://d2msbjewvfmcd5.cloudfront.net/Ford+and+the+Environment.mp4'
  },
  {
    backgroundImage: img8,//landscape
    mobileBackgroundImage: mobileImg8,
    id: 'lower-emissions',
    title: <>Ford is the only U.S. Automaker<sup className="clickable-asterik" onClick={openLegalText(LEGAL_TEXT_2)}>*</sup> to <b>stand with California</b> to lead the way on lower <b>greenhouse gas emissions.</b></>,
    ctaText: "See Our Path to a Low Carbon Economy",
    ctaUrl: 'https://media.ford.com/content/fordmedia/fna/us/en/news/2021/03/31/ford-integrated-sustainability-financial-report.html',
    finePrint: LEGAL_TEXT_2
  },
  {
    backgroundImage: img9,//wildfire
    mobileBackgroundImage: mobileImg9,
    id: 'wild-fires',
    title: <><b>The Ford Fund Supports CA Front Line Responders.</b></>,
    subtitle: <><div style={{textTransform: 'uppercase'}}>Provided <b>$300,000 in Financial Aid</b> over the last three years to CA-based Front Line efforts to fight Wildfires. </div><div style={{marginTop: 50, textTransform: 'uppercase'}}>A <b>100 Million-count Face Mask</b> distribution to those in at-risk areas.</div></>,
  }
]
